import { useHeatReportContext } from "@/pages/heat-report/context/HeatReportContext";
import { useTableStyles } from "@/pages/heat-report/styles/useTableStyles";
import { Box, Paper } from "@material-ui/core";
import { AgGridReact } from "ag-grid-react";
import { useTableData } from "./hooks/useTableData";

export const DelaysTable = () => {
	const classes = useTableStyles();
	const {
		state: { delays, eafProcessData },
	} = useHeatReportContext();

	const { columns, defaultColDef } = useTableData();
	return (
		<Paper className={classes.borderAgGridTable} elevation={0}>
			<Box p={0}>
				<div
					style={{ height: "25rem" }}
					key={`${delays.length}-${eafProcessData.ProcessId}`}
				>
					<AgGridReact
						rowSelection="single"
						suppressRowClickSelection={true}
						pagination={false}
						rowHeight={41}
						headerHeight={35}
						singleClickEdit={false}
						tooltipShowDelay={0}
						tooltipHideDelay={2000}
						rowData={delays}
						columnDefs={columns}
						domLayout="normal"
						getRowId={(params) => params.data.DelayId}
						suppressContextMenu
					/>
				</div>
			</Box>
		</Paper>
	);
};
